export const checkout = {
  upload: {
    choose3DFile: "3D-Datei hochladen",
    startDemo: "Demo starten",
    dontHaveAFileYet: "Keine 3D-Datei parat?",
    dragAndDrop3DFile: "3D-Datei per Drag & Drop hier in das Fenster ziehen",
    or: "oder",
    defaultHeader: "Online Bestellportal",
    defaultSubtitle: "Laden Sie hier Ihre Daten hoch",
    chooseDifferent3DFile: "Andere Datei hochladen",
    addAnother3DFile: "Weitere Datei hochladen",
    uploadState: {
      convertingToSTL: "Step-Datei wird konvertiert",
      analyzing: "Objekt wird analysiert",
      convertingToTRF: "Datei wird konvertiert",
      analyzingDimensions: "Objektgrösse wird berechnet",
      fileIsUploading: "Datei wird hochgeladen",
      repairing: "Datei wird repariert",
    },
  },
  analysis: {
    printQualityInfo: {
      tooLargeHeader: "Das Objekt ist zu gross für jeden Druck-Modus!",
      notPrintableHeader:
        "Das Bauteil ist in dieser Konfiguration nicht druckbar!",
      notPrintableBody:
        "Bitte wenden Sie sich über das Kontaktformular an unseren <a href='/kontakt#cart-steps' target='_blank'>Support</a> um ein unverbindliches Angebot zu erhalten.",
      mightCauseProblemsHeader: "Ihr Druckergebnis kann verbessert werden:",
      mightCauseProblemsBody:
        "Teile des Modells könnten bei der gewählten Skalierung zu dünn sein. Siehe <a href='/produktion/tipps-und-tricks-im-3d-druck#cart-steps' target='_blank'>Design-Guidelines</a>-",
      filePrintableHeader: "3D-Druck ist möglich:",
      filePrintableBody:
        "Unser automatischer Modellcheck hat keine Probleme gefunden. Bitte beachten Sie dennoch unsere <a href='/produktion/tipps-und-tricks-im-3d-druck#cart-steps' target='_blank'>Design-Guidelines</a>.",
      tooLargeForSelectedPrintmodeHeader:
        "Das Objekt ist zu gross für den gewählten Druck-Modus!",
      printabilityIsBeingCalculated: "Druckbarkeit wird berechnet",
    },
  },
  configure: {
    objectMeasurements: "Ihr Objekt hat die folgenden Abmessungen:",
    "3dRender": "3D-Ansicht",
    wallThicknesses: "Wandstärken",
    repairData: "ReparaturDaten",
    inputLabels: {
      objectName: "Objektname",
      givenUnitOfLength: "Welche Längeneinheit wurde verwendet?",
      materialAndColor: "Bitte wählen Sie Material und Farben:",
      scale: "Skalierung",
      unit: "Einheit",
      quantity: "Anzahl",
      finishOptions: "Oberflächenveredelung",
      untreated: "Unbehandelt",
    },
    rotateObjectInstruction: "Drehen Sie das Objekt durch ziehen mit der Maus",
  },
  nextStep: "Weiter",
  addToCart: "In den Warenkorb",
  steps: {
    choose3DFile: "3D-Datei hochladen",
    choosePrintMode: "Druckeinstellungen wählen",
    checkout: "Warenkorb",
  },
  cart: {
    label: "Warenkorb",
    cartIsEmpty: "Der Warenkorb ist leer.",
    editCart:"Warenkorb bearbeiten",
    actionLabels: {
      addToCart: "In den Warenkorb",
      generateQuote: "Angebot anfordern",
      completeOrder: "Jetzt bestellen",
      editPaymentDetails: "Zahlungsinformationen bearbeiten",
      chooseFinishes: "Weiter",
      goBack: "Zurück",
      close: "Schließen",
    },
    noTaxIncluded: "Steuern nicht mit inbegriffen",
    includingVAT: "alle Preise inklusive MwSt. (falls anzuwenden)",
    singlePriceIncludingXPercentTaxes: "inklusive {taxRate} % MwSt",
    includingXPercentTaxes: "alle Preise inklusive {taxRate} % MwSt",
    plusXPercentTaxes: "zzgl. {taxRate} % MwSt",
    isPiecePrice: "Preis pro Stück",
    isFullPrice: "Gesamt",
    itemLabels: {
      name: "Artikel",
      size: "Grösse in ",
      sizeInCM: "Grösse in CM",
      printMode: "Material / Farbe",
      quantity: "Anzahl",
      priceSingle: "Stück",
      priceSum: "Gesamt",
      delete: "Löschen",
      attachments: "Anhänge",
      uploadAttachment: "Anhang hochladen",
    },
  },
  condition1: "Ich habe die",
  condition2: "Allgemeinen Geschäftsbedingungen",
  condition3: "gelesen und stimme ihnen zu.",
  orderStatusLabels: {
    QUOTE_GENERATED: "Angebot angefordert",
    ORDER_RECEIVED: "Bestellung eingegangen",
    READY_FOR_PROCESSING: "Bereit zur Abfertigung",
    CUSTOMER_CONTACTED: "Kunde kontaktiert",
    FILES_PRINTABLE: "Dateien druckbar",
    FILES_REPAIRED: "Datei wurde repariert",
    FILES_NOT_PRINTABLE: "Dateien nicht druckbar",
    SUPPLIER_REQUEST_SENT: "Anfrage an Zulieferer Versendet",
    IN_PRODUCTION: "Teile in Produktion",
    PARTS_DEFECTIVE: "Teile defekt",
    PARTS_REVIEWED: "Teile fehlerfrei",
    ORDER_CANCELLED: "Auftrag abgebrochen",
    ORDER_COMPLETED: "Auftrag abgeschlossen",
    UNKNOWN: "Offen",
  },
  paymentMethodLabels: {
    prepaid: "Vorkasse",
    billing: "Auf Rechnung",
    quote: "Angebot angefordert",
    paypal: "PayPal",
  },
  productionTime: "Produktionszeit",
  deliveryTime: "Lieferzeit",
  totalDeliveryTime: "Voraussichtl. Gesamtlieferzeit",
  totalShippingTime: "Voraussichtl. Versandzeit",
  productionTimeDays: "0 Arbeitstage | 1 Arbeitstag | {n} Arbeitstage ",
  paymentDetails: {
    totalPrice: "GesamtPreis (ohne Versand)",
    minimumQuantitySurcharge: "Mindermengenzuschlag",
    sippingCost: "Versandkosten",
    subTotal: "Zwischensumme",
    totalPaymentAmount: "Zahlungsbetrag Gesamt",
    netPrice: "Nettopreis",
    sumPrice: "Bruttopreis",
    customerAndPaymentDetails: "Kunde und Zahlungsmethode",
    completeYourOrder: "Schliessen Sie Ihren Auftrag ab",
    customer: "Kunde",
    billingAddress: "Rechnungsadresse",
    shippingAddress: "Lieferadresse",
    diffrentShippingAddress: "abweichend wie Lieferadresse",
    yourMessageToUs: "Ihre Nachricht an uns",
    label: "Label",
    button: "Button",
    mailing: "E-Mails",
    address: "Adresse",
    client: "Kunde",
    shippingCost: "Versandkosten",
    inputLabels: {
      firstName: "Vorname",
      lastName: "Nachname",
      email: "E-Mail",
      phone: "Telefon",
      company: "Firma oder Abteilung",
      referenceNumber: "Referenznummer",
      street: "Strasse und Hausnummer",
      postalCode: "Postleitzahl",
      city: "Ort",
      country: "Land",
      shippingAddressDiffersFromBillingAddress:
        "abweichend von Rechnungsadresse",
      paymentMethod: "Zahlungsmethode",
      vatRegistrationNumber: "USt-ID",
      businessOrPrivateCustomer: "Sie sind:",
      businessCustomer: "Firmenkunde",
      privateCustomer: "Privatkunde",
      saveNewAddress: "Neue Adresse für meinen nächsten Auftrag speichern",
      useSeperateBillingEmail:
        "Eine zweite E-Mail Adresse für den Rechnungsversand hinterlegen",
      primaryEmail: "Auftragsbestätigung und Statusupdates an",
      billingEmail: "Rechnung zusätzlich an",
    },
    paymentMethod: "Zahlungsmethode",
  },
  requiredInput: {
    someWith: "Einige mit",
    notFilled: "markierte Pflichtfelder sind noch nicht ausgefüllt."
  },
  finaliseOrder: {
    buyNow: "Zahlungspflichtig bestellen",
    goToPayPal: "Weiter zu PayPal",
    getQuote: "Angebot anfordern",
    thankYouForOrdering: "Vielen Dank für Ihre Bestellung.",
    orderConfirmationSentTo:
      'Wir haben Ihnen eine Eingangsbestätigung per E-Mail an <span class="has-text-primary">{email}</span> versendet.',
    paymentConfirmationSentTo:
      'Wir haben Ihnen eine Zahlungsbestätigung per E-Mail an <span class="has-text-primary">{email}</span> versendet.',
  },
  billing: "Rechnung",
  quote: "unverbindliches Angebot anfordern",
  quoteGenerated: {
    headline: "Vielen Dank für Ihre Anfrage",
    emailSentTo:
      'Wir haben ein Angebot per E-Mail an <span class="has-text-primary">{email}</span> versendet.',
    emailSent: "Wir haben ein Angebot per E-Mail an Sie versendet",
  },
  orderCompleted: {},
};
